<template>
  <div class="fill-height col-12 ma-0 pa-2">
    <div class="px-2 mb-6" v-if="mode !== 'widget'">
      <v-divider></v-divider>
    </div>
    
    <!-- DETAILS/WIDGET MODE -->
    <v-card
        v-if="ready"
        height="100%"
        class="rounded-lg"
        :color="mode === 'widget' ? '' : 'transparent'"
        :tile="mode !== 'widget'"
        flat
    >
<!--      <v-card-title v-if="mode === 'widget'" class="black&#45;&#45;text"><strong>{{ challengeTitle }}</strong></v-card-title>-->
      
      <div class="px-4" v-if="mode !== 'widget'">
        <v-tabs
            grow
            show-arrows
        >
          <v-tab @click.prevent="setView('goal')" v-if="challenge.properties.goalType">
            {{ $t('weFitter.goal') }}
          </v-tab>
          <v-tab @click.prevent="setView('locations')" v-if="challenge.properties.showLocLeaderboard === 'true'">
            {{ $t('weFitter.leaderboard') }} : {{ $t('weFitter.locations') }}
          </v-tab>
          <v-tab @click.prevent="setView('teams')" v-if="challenge.properties.showDptLeaderboard === 'true'">
            {{ $t('weFitter.leaderboard') }} : {{ $t('weFitter.departments') }}
          </v-tab>
          <v-tab @click.prevent="setView('organisations')" v-if="challenge.properties.showOrgLeaderboard === 'true'">
            {{ $t('weFitter.leaderboard') }} : {{ $t('weFitter.organisations') }}
          </v-tab>

          <v-tab @click.prevent="setView('locationsPersons')" v-if="challenge.properties.showLocLeaderboardPersons === 'true'">
            {{ $t('weFitter.leaderboard') }} : {{ $t('weFitter.locationsPersons') }}
          </v-tab>
          <v-tab @click.prevent="setView('teamsPersons')" v-if="challenge.properties.showDptLeaderboardPersons === 'true'">
            {{ $t('weFitter.leaderboard') }} : {{ $t('weFitter.departmentsPersons') }}
          </v-tab>
          <v-tab @click.prevent="setView('organisationsPersons')" v-if="challenge.properties.showOrgLeaderboardPersons === 'true'">
            {{ $t('weFitter.leaderboard') }} : {{ $t('weFitter.organisationsPersons') }}
          </v-tab>
        </v-tabs>
      </div>
      <div class="px-4" v-if="mode === 'widget'">
        <v-tabs
            grow
            show-arrows
        >
          <v-tab @click.prevent="setView('goal')" v-if="challenge.properties.goalType">
            {{ $t('weFitter.goal') }}
          </v-tab>
          <v-tab @click.prevent="setView('locations')" v-if="challenge.properties.showLocLeaderboard === 'true'">
            {{ challenge.translation.title }} : {{ $t('weFitter.topLocations') }}
          </v-tab>
          <v-tab @click.prevent="setView('teams')" v-if="challenge.properties.showDptLeaderboard === 'true'">
            {{ challenge.translation.title }} : {{ $t('weFitter.topDepartments') }}
          </v-tab>
          <v-tab @click.prevent="setView('organisations')" v-if="challenge.properties.showOrgLeaderboard === 'true'">
            {{ challenge.translation.title }} : {{ $t('weFitter.topOrganisations') }}
          </v-tab>

          <v-tab @click.prevent="setView('locationsPersons')" v-if="challenge.properties.showLocLeaderboardPersons === 'true'">
            {{ challenge.translation.title }} : {{ $t('weFitter.locationsPersons') }}
          </v-tab>
          <v-tab @click.prevent="setView('teamsPersons')" v-if="challenge.properties.showDptLeaderboardPersons === 'true'">
            {{ challenge.translation.title }} : {{ $t('weFitter.departmentsPersons') }}
          </v-tab>
          <v-tab @click.prevent="setView('organisationsPersons')" v-if="challenge.properties.showOrgLeaderboardPersons === 'true'">
            {{ challenge.translation.title }} : {{ $t('weFitter.organisationsPersons') }}
          </v-tab>
        </v-tabs>
      </div>

      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>

      <!-- GOAL RANKING -->
      <v-card-text v-if="!isLoading && view === 'goal' && leaderboardGoal" class="fill-height">
        <div
            class="d-flex flex-nowrap align-center"
        >
          <!--<div class="col-1 pa-1 d-flex justify-center align-center">
             <h2>{{ item.ranking }}</h2>
          </div>-->
          <div class="col-12 pa-1 d-flex justify-center align-center">
            <v-progress-linear
                color="info"
                height="60"
                rounded
                class="rounded-pill d-flex flex-nowrap elevation-1"
                :value="(leaderboardGoal.total / parseInt(challenge.properties.goal)) * 100"
            >
              <!--<div class="col-1 ma-0 pa-0">
                <v-avatar color="primary" size="60">
                  <h2 class="white--text">{{ item.ranking }}</h2>
                </v-avatar>
              </div>-->
              <div class="col-6 ma-0 px-6">
                <div><strong>{{ leaderboardGoal.name }}</strong></div>
                <div>{{ $t('weFitter.participants') }}: {{ leaderboardGoal.participants }}</div>
              </div>
              <div class="col-6 ma-0 px-6">
                {{ leaderboardGoal.total }} / {{ parseInt(challenge.properties.goal) }} {{ $t('weFitter.parameters.' + challenge.properties.weFitterParameter ) }} ({{ Math.round((leaderboardGoal.total / parseInt(challenge.properties.goal)) * 100) }}%)
              </div>
            </v-progress-linear>
          </div>
        </div>
      </v-card-text>
      
      <!-- LOCATION RANKING -->
      <v-card-text v-if="!isLoading && view === 'locations' && locationRanking.length" class="fill-height">
        <template v-for="(item) in locationRanking">
          <div
              :key="item.identifier"
              class="d-flex flex-nowrap align-center"
          >
            <!--<div class="col-1 pa-1 d-flex justify-center align-center">
               <h2>{{ item.ranking }}</h2>
            </div>-->
            <div class="col-12 pa-1 d-flex justify-center align-center">
              <v-progress-linear
                  :color="item.myTeam ? 'info' : 'info lighten-2'"
                  height="60"
                  :class="item.myTeam ? 'elevation-1' : ''"
                  rounded
                  class="rounded-pill d-flex flex-nowrap"
                  :value="(item.average / locAverageMax) * 100"
              >
                <div class="col-1 ma-0 pa-0">
                  <v-avatar color="primary" size="60">
                    <!--<v-img :src="item.avatar"></v-img>-->
                    <h2 class="white--text">{{ item.ranking }}</h2>
                  </v-avatar>
                </div>
                <div class="col-5 ma-0 px-6">
                  <div><strong>{{ $t('weFitter.location') }}: {{ item.name }}</strong></div>
                  <div>{{ $t('weFitter.participants') }}: {{ item.participants }}</div>
                </div>
                <div class="col-6 ma-0 px-6">
                  {{ $t('weFitter.avg') + ' ' + item.average }} {{ $t('weFitter.parameters.' + challenge.properties.weFitterParameter ) }}
                </div>
              </v-progress-linear>
            </div>
          </div>
        </template>
      </v-card-text>
      
      <!-- DEPARTMENT RANKING -->
      <v-card-text v-if="!isLoading && view === 'teams' && departmentRanking.length" class="fill-height">
          <template v-for="(item) in departmentRanking">
            <div
                :key="item.identifier"
                class="d-flex flex-nowrap align-center"
            >
              <!--<div class="col-1 pa-1 d-flex justify-center align-center">
                 <h2>{{ item.ranking }}</h2>
              </div>-->
              <div class="col-12 pa-1 d-flex justify-center align-center">
                <v-progress-linear
                    :color="item.myTeam ? 'info' : 'info lighten-2'"
                    height="60"
                    :class="item.myTeam ? 'elevation-1' : ''"
                    rounded
                    class="rounded-pill d-flex flex-nowrap"
                    :value="(item.average / dptAverageMax) * 100"
                >
                  <div class="col-1 ma-0 pa-0">
                    <v-avatar color="primary" size="60">
                      <!--<v-img :src="item.avatar"></v-img>-->
                      <h2 class="white--text">{{ item.ranking }}</h2>
                    </v-avatar>
                  </div>
                  <div class="col-5 ma-0 px-6">
                    <div><strong>{{ $t('weFitter.department') }}: {{ item.name }}</strong></div>
                    <div>{{ $t('weFitter.participants') }}: {{ item.participants }}</div>
                  </div>
                  <div class="col-6 ma-0 px-6">
                    {{ $t('weFitter.avg') + ' ' + item.average }} {{ $t('weFitter.parameters.' + challenge.properties.weFitterParameter ) }}
                  </div>
                </v-progress-linear>
              </div>
            </div>
          </template>
      </v-card-text>

      <!-- ORGANISATION RANKING -->
      <v-card-text v-if="!isLoading && view === 'organisations' && organisationRanking.length" class="fill-height">
        <template v-for="(item) in organisationRanking">
          <div
              :key="item.identifier"
              class="d-flex flex-nowrap align-center"
          >
            <!--<div class="col-1 pa-1 d-flex justify-center align-center">
              <h2>{{ item.ranking }}</h2>
            </div>-->
            <div class="col-12 pa-1 d-flex justify-center align-center">
              <v-progress-linear
                  :color="item.myTeam ? 'info' : 'info lighten-2'"
                  height="60"
                  :class="item.myTeam ? 'elevation-1' : ''"
                  rounded
                  class="rounded-pill d-flex flex-nowrap"
                  :value="(item.average / orgAverageMax) * 100"
              >
                <div class="col-1 ma-0 pa-0">
                  <v-avatar :color="item.organisationLogo ? 'white' : 'primary'" size="60">
                    <!--<v-img v-if="item.organisationLogo" :src="item.organisationLogo" width="60" height="60"></v-img>-->
                    <h2 class="white--text">{{ item.ranking }}</h2>
                  </v-avatar>
                </div>
                <div class="col-5 ma-0 px-6">
                  <div><strong>{{ item.name }}</strong></div>
                  <div>{{ $t('weFitter.participants') }}: {{ item.participants }}</div>
                </div>
                <div class="col-6 ma-0 px-6">
                  {{ $t('weFitter.avg') + ' ' + item.average }} {{ $t('weFitter.parameters.' + challenge.properties.weFitterParameter ) }}
                </div>
              </v-progress-linear>
            </div>
          </div>
        </template>
      </v-card-text>

      <!-- LOCATION PERSON RANKING -->
      <v-card-text v-if="!isLoading && view === 'locationsPersons' && locationPersonRanking.length" class="fill-height">
        <template v-for="(item) in locationPersonRanking">
          <div
              :key="item.identifier"
              class="d-flex flex-nowrap align-center"
          >
            <!--<div class="col-1 pa-1 d-flex justify-center align-center">
               <h2>{{ item.ranking }}</h2>
            </div>-->
            <div class="col-12 pa-1 d-flex justify-center align-center">
              <v-progress-linear
                  :color="item.myTeam ? 'info' : 'info lighten-2'"
                  height="60"
                  :class="item.myTeam ? 'elevation-1' : ''"
                  rounded
                  class="rounded-pill d-flex flex-nowrap"
                  :value="(item.total / locPersonMax) * 100"
              >
                <div class="col-1 ma-0 pa-0">
                  <v-avatar color="primary" size="60">
                    <!--<v-img :src="item.avatar"></v-img>-->
                    <h2 class="white--text">{{ item.ranking }}</h2>
                  </v-avatar>
                </div>
                <div class="col-5 ma-0 px-6">
                  <div><strong>{{ item.name }}</strong></div>
                </div>
                <div class="col-6 ma-0 px-6">
                  {{ item.total }} {{ $t('weFitter.parameters.' + challenge.properties.weFitterParameter ) }}
                </div>
              </v-progress-linear>
            </div>
          </div>
        </template>
      </v-card-text>

      <!-- DEPARTMENT PERSON RANKING -->
      <v-card-text v-if="!isLoading && view === 'teamsPersons' && departmentPersonRanking.length" class="fill-height">
        <template v-for="(item) in departmentPersonRanking">
          <div
              :key="item.identifier"
              class="d-flex flex-nowrap align-center"
          >
            <!--<div class="col-1 pa-1 d-flex justify-center align-center">
               <h2>{{ item.ranking }}</h2>
            </div>-->
            <div class="col-12 pa-1 d-flex justify-center align-center">
              <v-progress-linear
                  :color="item.myTeam ? 'info' : 'info lighten-2'"
                  height="60"
                  :class="item.myTeam ? 'elevation-1' : ''"
                  rounded
                  class="rounded-pill d-flex flex-nowrap"
                  :value="(item.total / dptPersonMax) * 100"
              >
                <div class="col-1 ma-0 pa-0">
                  <v-avatar color="primary" size="60">
                    <!--<v-img :src="item.avatar"></v-img>-->
                    <h2 class="white--text">{{ item.ranking }}</h2>
                  </v-avatar>
                </div>
                <div class="col-5 ma-0 px-6">
                  <div><strong>{{ item.name }}</strong></div>
                </div>
                <div class="col-6 ma-0 px-6">
                  {{ item.total }} {{ $t('weFitter.parameters.' + challenge.properties.weFitterParameter ) }}
                </div>
              </v-progress-linear>
            </div>
          </div>
        </template>
      </v-card-text>

      <!-- ORGANISATION PERSON RANKING -->
      <v-card-text v-if="!isLoading && view === 'organisationsPersons' && organisationPersonRanking.length" class="fill-height">
        <template v-for="(item) in organisationPersonRanking">
          <div
              :key="item.identifier"
              class="d-flex flex-nowrap align-center"
          >
            <!--<div class="col-1 pa-1 d-flex justify-center align-center">
               <h2>{{ item.ranking }}</h2>
            </div>-->
            <div class="col-12 pa-1 d-flex justify-center align-center">
              <v-progress-linear
                  :color="item.myTeam ? 'info' : 'info lighten-2'"
                  height="60"
                  :class="item.myTeam ? 'elevation-1' : ''"
                  rounded
                  class="rounded-pill d-flex flex-nowrap"
                  :value="(item.total / orgPersonMax) * 100"
              >
                <div class="col-1 ma-0 pa-0">
                  <v-avatar color="primary" size="60">
                    <!--<v-img :src="item.avatar"></v-img>-->
                    <h2 class="white--text">{{ item.ranking }}</h2>
                  </v-avatar>
                </div>
                <div class="col-5 ma-0 px-6">
                  <div><strong>{{ item.name }}</strong></div>
                </div>
                <div class="col-6 ma-0 px-6">
                  {{ item.total }} {{ $t('weFitter.parameters.' + challenge.properties.weFitterParameter ) }}
                </div>
              </v-progress-linear>
            </div>
          </div>
        </template>
      </v-card-text>

      <v-card-actions class="justify-end pt-0" v-if="!isLoading && mode === 'widget'">
        <v-btn text color="primary" @click.prevent="navigate('/challenges/' + challengeId)">
          {{ $t('weFitter.showFullLeaderboard') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-wefitter-challenge-widget",
  props: ['mode', 'challenge', 'challengeId'],
  data() {
    return {
      isLoading: false,
      profile: {},
      data: {},
      departmentRanking: [],
      organisationRanking: [],
      locationRanking: [],
      organisationPersonRanking: [],
      departmentPersonRanking: [],
      locationPersonRanking: [],
      orgAverageMax: 0,
      dptAverageMax: 0,
      locAverageMax: 0,
      orgPersonMax: 0,
      dptPersonMax: 0,
      locPersonMax: 0,
      leaderboardGoal: {},
      view: 'teams',
      ready: false
    }
  },

  async mounted(){
    if (this.challenge.properties.goalType) { this.view = 'goal' }
    else if (this.challenge.properties.showLocLeaderboard === 'true') { this.view = 'locations' }
    else if (this.challenge.properties.showDptLeaderboard === 'true') { this.view = 'teams' }
    else if (this.challenge.properties.showOrgLeaderboard === 'true') { this.view = 'organisations' }
    else if (this.challenge.properties.showLocLeaderboardPersons === 'true') { this.view = 'locationsPersons' }
    else if (this.challenge.properties.showDptLeaderboardPersons === 'true') { this.view = 'teamsPersons' }
    else if (this.challenge.properties.showOrgLeaderboardPersons === 'true') { this.view = 'organisationsPersons' }
    else { this.view = 'organisations' }
    await this.fetchProfile()
    await this.fetchChallengeResults()
    this.ready = true
  },

  methods: {
    async fetchProfile(){
      await api.account.getProfile()
          .then((res) => {
            this.profile = res.data
          })
    },
    async fetchChallengeResults(){
      let requestModel = {
        type: this.challenge.properties.weFitterType,
        registrationModuleId: this.challenge.registrationModule.identifier,
        includeUserGroupNames: true
      }
      if (this.challenge.properties.weFitterType === 'workout' && this.challenge.properties.weFitterWorkoutType) { requestModel.subType = this.challenge.properties.weFitterWorkoutType }
      if (this.challenge.properties.dataFrom) { requestModel.from = this.challenge.properties.dataFrom }
      if (this.challenge.properties.dataUntil) { requestModel.until = this.challenge.properties.dataUntil }
      this.data = await api.weFitter.getWefitterData(requestModel).then((res) => { return res.data })
      await this.calculateRankings()
    },
    
    async calculateRankings(){
      await this.calculateOrganizationRankings()
      await this.calculateDepartmentRankings()
      await this.calculateLocationRankings()
      await this.calculateLeaderboardGoal()
      await this.calculateOrganizationPersonRankings()
      await this.calculateDepartmentPersonRankings()
      await this.calculateLocationPersonRankings()
    },
    
    async calculateOrganizationRankings(){
      let parameter = this.challenge.properties.weFitterParameter || 'steps'
      this.data.userRegistrations.forEach((x) => {
        let results = this.data.weFitterData.filter((data) => { return data.userId === x.userId})
        let total = 0
        results.forEach((result) => {
          total += result[parameter]
        })
        
        let org = this.organisationRanking.find((orgRank) => { return orgRank.identifier === x.userOrganizationId})
        if (org){
          org.total += total
          org.participants += 1
          if (org.identifier === this.profile.organizationId){ org.myTeam = true }
          org.average = Math.round(org.total / org.participants)
        } else {
          this.organisationRanking.push(
              {
                identifier: x.userOrganizationId,
                name: x.userOrganizationName,
                total: total,
                average: total,
                participants: 1,
                myTeam: this.profile.organizationId === x.userOrganizationId
              }
          )
        }
      })
      this.organisationRanking = this.organisationRanking.sort((a, b) => { return b.average - a.average })
      this.organisationRanking.forEach((ranking, index) => {
        ranking.ranking = index + 1
      })
      if (this.organisationRanking.length) { this.orgAverageMax = this.organisationRanking[0].average }
      if (this.mode === 'widget'){
        let myTeam = this.organisationRanking.find((x) => { return x.myTeam })
        if (myTeam && myTeam.ranking && myTeam.ranking > 4){
          this.organisationRanking = this.organisationRanking.slice(0,3)
          this.organisationRanking.push(myTeam)
        } else {
          this.organisationRanking = this.organisationRanking.slice(0,4)
        }
      }
    },

    async calculateDepartmentRankings(){
      let parameter = this.challenge.properties.weFitterParameter || 'steps'
      let registrations = this.data.userRegistrations.filter((x) => { return x.userOrganizationId === this.profile.organizationId})
      registrations.forEach((x) => {
        let results = this.data.weFitterData.filter((data) => { return data.userId === x.userId})
        let total = 0
        results.forEach((result) => {
          total += result[parameter]
        })

        let dpt = this.departmentRanking.find((dptRank) => { return dptRank.identifier === x.userDepartmentId})
        if (dpt){
          dpt.total += total
          dpt.participants += 1
          if (dpt.identifier === this.profile.departmentId){ dpt.myTeam = true }
          dpt.average = Math.round(dpt.total / dpt.participants)
        } else {
          this.departmentRanking.push(
              {
                identifier: x.userDepartmentId,
                name: x.userDepartmentName,
                total: total,
                average: total,
                participants: 1,
                myTeam: this.profile.departmentId === x.userDepartmentId
              }
          )
        }
      })
      this.departmentRanking = this.departmentRanking.sort((a, b) => { return b.average - a.average })
      this.departmentRanking.forEach((ranking, index) => {
        ranking.ranking = index + 1
      })
      if (this.departmentRanking.length) { this.dptAverageMax = this.departmentRanking[0].average }
      if (this.mode === 'widget'){
        let myTeam = this.departmentRanking.find((x) => { return x.myTeam })
        if (myTeam && myTeam.ranking && myTeam.ranking > 4){
          this.departmentRanking = this.departmentRanking.slice(0,3)
          this.departmentRanking.push(myTeam)
        } else {
          this.departmentRanking = this.departmentRanking.slice(0,4)
        }
      }
    },

    async calculateLocationRankings(){
      let parameter = this.challenge.properties.weFitterParameter || 'steps'
      let registrations = this.data.userRegistrations.filter((x) => { return x.userOrganizationId === this.profile.organizationId})
      registrations.forEach((x) => {
        let results = this.data.weFitterData.filter((data) => { return data.userId === x.userId})
        let total = 0
        results.forEach((result) => {
          total += result[parameter]
        })

        let loc = this.locationRanking.find((locRank) => { return locRank.identifier === x.userLocationId})
        if (loc){
          loc.total += total
          loc.participants += 1
          if (loc.identifier === this.profile.locationId){ loc.myTeam = true }
          loc.average = Math.round(loc.total / loc.participants)
        } else {
          this.locationRanking.push(
              {
                identifier: x.userLocationId,
                name: x.userLocationName,
                total: total,
                average: total,
                participants: 1,
                myTeam: this.profile.locationId === x.userLocationId
              }
          )
        }
      })
      this.locationRanking = this.locationRanking.sort((a, b) => { return b.average - a.average })
      this.locationRanking.forEach((ranking, index) => {
        ranking.ranking = index + 1
      })
      if (this.locationRanking.length) { this.locAverageMax = this.locationRanking[0].average }
      if (this.mode === 'widget'){
        let myTeam = this.locationRanking.find((x) => { return x.myTeam })
        if (myTeam && myTeam.ranking && myTeam.ranking > 4){
          this.locationRanking = this.locationRanking.slice(0,3)
          this.locationRanking.push(myTeam)
        } else {
          this.locationRanking = this.locationRanking.slice(0,4)
        }
      }
    },

    async calculateLeaderboardGoal(){
      if (this.challenge.properties.goalType === 'organization') {
        this.leaderboardGoal = this.organisationRanking.find((x) => { return x.identifier === this.profile.organizationId }) 
      }
      if (this.challenge.properties.goalType === 'department') {
        this.leaderboardGoal = this.departmentRanking.find((x) => { return x.identifier === this.profile.departmentId })
      }
      if (this.challenge.properties.goalType === 'location') {
        this.leaderboardGoal = this.locationRanking.find((x) => { return x.identifier === this.profile.locationId })
      }
    },

    async calculateLocationPersonRankings(){
      let parameter = this.challenge.properties.weFitterParameter || 'steps'
      let registrations = this.data.userRegistrations.filter((x) => { return x.userLocationId === this.profile.locationId})
      registrations.forEach((x) => {
        let results = this.data.weFitterData.filter((data) => { return data.userId === x.userId})
        let total = 0
        results.forEach((result) => {
          total += result[parameter]
        })

        let locPers = this.locationPersonRanking.find((locPersRank) => { return locPersRank.identifier === x.userId})
        if (locPers){
          locPers.total += total
          if (locPers.identifier === this.profile.identifier){ locPers.myTeam = true }
        } else {
          this.locationPersonRanking.push(
              {
                identifier: x.userId,
                name: x.userSummary.firstName + ' ' + x.userSummary.lastName,
                total: total,
                myTeam: this.profile.identifier === x.userId
              }
          )
        }
      })
      this.locationPersonRanking = this.locationPersonRanking.sort((a, b) => { return b.total - a.total })
      this.locationPersonRanking.forEach((ranking, index) => {
        ranking.ranking = index + 1
      })
      if (this.locationPersonRanking.length) { this.locPersonMax = this.locationPersonRanking[0].total }
      if (this.mode === 'widget'){
        let myTeam = this.locationPersonRanking.find((x) => { return x.myTeam })
        if (myTeam && myTeam.ranking && myTeam.ranking > 4){
          this.locationPersonRanking = this.locationPersonRanking.slice(0,3)
          this.locationPersonRanking.push(myTeam)
        } else {
          this.locationPersonRanking = this.locationPersonRanking.slice(0,4)
        }
      }
    },

    async calculateDepartmentPersonRankings(){
      let parameter = this.challenge.properties.weFitterParameter || 'steps'
      let registrations = this.data.userRegistrations.filter((x) => { return x.userDepartmentId === this.profile.departmentId})
      registrations.forEach((x) => {
        let results = this.data.weFitterData.filter((data) => { return data.userId === x.userId})
        let total = 0
        results.forEach((result) => {
          total += result[parameter]
        })

        let dptPers = this.departmentPersonRanking.find((dptPersRank) => { return dptPersRank.identifier === x.userId})
        if (dptPers){
          dptPers.total += total
          if (dptPers.identifier === this.profile.identifier){ dptPers.myTeam = true }
        } else {
          this.departmentPersonRanking.push(
              {
                identifier: x.userId,
                name: x.userSummary.firstName + ' ' + x.userSummary.lastName,
                total: total,
                myTeam: this.profile.identifier === x.userId
              }
          )
        }
      })
      this.departmentPersonRanking = this.departmentPersonRanking.sort((a, b) => { return b.total - a.total })
      this.departmentPersonRanking.forEach((ranking, index) => {
        ranking.ranking = index + 1
      })
      if (this.departmentPersonRanking.length) { this.dptPersonMax = this.departmentPersonRanking[0].total }
      if (this.mode === 'widget'){
        let myTeam = this.departmentPersonRanking.find((x) => { return x.myTeam })
        if (myTeam && myTeam.ranking && myTeam.ranking > 4){
          this.departmentPersonRanking = this.departmentPersonRanking.slice(0,3)
          this.departmentPersonRanking.push(myTeam)
        } else {
          this.departmentPersonRanking = this.departmentPersonRanking.slice(0,4)
        }
      }
    },

    async calculateOrganizationPersonRankings(){
      let parameter = this.challenge.properties.weFitterParameter || 'steps'
      let registrations = this.data.userRegistrations.filter((x) => { return x.userOrganizationId === this.profile.organizationId})
      registrations.forEach((x) => {
        let results = this.data.weFitterData.filter((data) => { return data.userId === x.userId})
        let total = 0
        results.forEach((result) => {
          total += result[parameter]
        })

        let orgPers = this.organisationPersonRanking.find((orgPersRank) => { return orgPersRank.identifier === x.userId})
        if (orgPers){
          orgPers.total += total
          if (orgPers.identifier === this.profile.identifier){ orgPers.myTeam = true }
        } else {
          this.organisationPersonRanking.push(
              {
                identifier: x.userId,
                name: x.userSummary.firstName + ' ' + x.userSummary.lastName,
                total: total,
                myTeam: this.profile.identifier === x.userId
              }
          )
        }
      })
      this.organisationPersonRanking = this.organisationPersonRanking.sort((a, b) => { return b.total - a.total })
      this.organisationPersonRanking.forEach((ranking, index) => {
        ranking.ranking = index + 1
      })
      if (this.organisationPersonRanking.length) { this.orgPersonMax = this.organisationPersonRanking[0].total }
      if (this.mode === 'widget'){
        let myTeam = this.organisationPersonRanking.find((x) => { return x.myTeam })
        if (myTeam && myTeam.ranking && myTeam.ranking > 4){
          this.organisationPersonRanking = this.organisationPersonRanking.slice(0,3)
          this.organisationPersonRanking.push(myTeam)
        } else {
          this.organisationPersonRanking = this.organisationPersonRanking.slice(0,4)
        }
      }
    },
    
    

    setView(view) {
      this.view = view
    },

    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
  }
}
</script>

<style scoped>

</style>
